// Lưu file về máy — thống nhất cho cả WEB và APP NATIVE (Capacitor).
// WebView Android KHÔNG tự lưu file khi bấm link download / blob như trình duyệt,
// nên trên native phải ghi file rồi mở "share sheet" để người dùng Lưu vào Files / gửi Zalo...
import { Capacitor } from '@capacitor/core';

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onloadend = () => resolve(String(r.result).split(',')[1] || '');
    r.onerror = reject;
    r.readAsDataURL(blob);
  });
}

function safeName(name) {
  return (name || 'file').replace(/[/\\?%*:|"<>]+/g, '_').slice(0, 120);
}

// saveFile({ blob }) — lưu 1 Blob (vd CSV/Excel tạo tại client)
// saveFile({ url, filename }) — tải từ URL (vd file đính kèm chat) rồi lưu
export async function saveFile({ blob, url, filename }) {
  const name = safeName(filename);

  // WEB: giữ NGUYÊN hành vi cũ (link download / mở tab mới).
  if (!Capacitor?.isNativePlatform?.()) {
    const href = url || URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = href;
    a.download = name;
    if (url) { a.target = '_blank'; a.rel = 'noreferrer'; }
    document.body.appendChild(a);
    a.click();
    a.remove();
    if (!url) setTimeout(() => URL.revokeObjectURL(href), 2000);
    return;
  }

  // NATIVE: ghi file vào Cache rồi mở share sheet.
  const { Filesystem, Directory } = await import('@capacitor/filesystem');
  const { Share } = await import('@capacitor/share');
  let b = blob;
  if (!b && url) {
    const res = await fetch(url, { credentials: 'include' });
    if (!res.ok) throw new Error('Tải file lỗi HTTP ' + res.status);
    b = await res.blob();
  }
  if (!b) throw new Error('Không có dữ liệu file');
  const base64 = await blobToBase64(b);
  const written = await Filesystem.writeFile({ path: name, data: base64, directory: Directory.Cache });
  try {
    await Share.share({ title: name, url: written.uri });
  } catch (e) {
    // Người dùng bấm hủy share -> bỏ qua (file đã ghi ở Cache).
  }
}

// Đoán TÊN TỆP để lưu 1 ảnh: ưu tiên tên đính kèm có đuôi ảnh; nếu không lấy tên cuối trong URL;
// cuối cùng suy đuôi từ mime của dataURL (mặc định .jpg). Giúp ảnh tải về có tên/đuôi hợp lý.
function guessImageName(src, filename) {
  const IMG = /\.(jpe?g|png|gif|webp|bmp|heic|heif|svg|avif)$/i;
  const fn = (filename || '').trim();
  if (fn && IMG.test(fn)) return fn;
  const s = src || '';
  if (s && !s.startsWith('data:') && !s.startsWith('blob:')) {
    try {
      const seg = decodeURIComponent(s.split(/[?#]/)[0].split('/').pop() || '');
      if (seg && /\.[a-z0-9]{2,5}$/i.test(seg)) return seg;
    } catch { /* url lạ -> bỏ qua, dùng phương án dưới */ }
  }
  let ext = 'jpg';
  const m = /^data:image\/([a-z0-9.+-]+)/i.exec(s);
  if (m) ext = m[1].toLowerCase() === 'jpeg' ? 'jpg' : m[1].toLowerCase();
  const base = (fn && fn.replace(/\.[^.]*$/, '')) || 'anh';
  return `${base}.${ext}`;
}

// TẢI 1 ẢNH ĐANG XEM (lightbox) về máy. Web: fetch -> blob -> lưu, tải được cả ảnh KHÁC NGUỒN GỐC
// (vd media khách hàng) mà không bị mở tab; nếu fetch lỗi (CORS/mạng) thì dự phòng bằng <a download>/mở tab.
// Native (Capacitor): saveFile ghi file rồi mở share sheet để Lưu vào Ảnh/Files.
export async function saveImage(src, filename) {
  if (!src) return;
  const name = guessImageName(src, filename);
  try {
    const res = await fetch(src);
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const blob = await res.blob();
    await saveFile({ blob, filename: name });
  } catch (e) {
    await saveFile({ url: src, filename: name }); // dự phòng khi không fetch được blob
  }
}

// Dùng cho thẻ <a> đính kèm: CHỈ chặn trên native; web để <a download> chạy như cũ.
export function onAttachmentClick(url, filename) {
  return (e) => {
    if (!Capacitor?.isNativePlatform?.()) return; // web: không đụng vào
    e.preventDefault();
    saveFile({ url, filename }).catch((err) => console.error('[download] lỗi:', err?.message || err));
  };
}
